import { MRT_Localization_CS } from "material-react-table/locales/cs";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { useLanguage } from "Translations/useLanguage";

export const useTableLocalization = () => {
  const { currentLanguage } = useLanguage();

  const localization =
    currentLanguage === "en" ? MRT_Localization_EN : MRT_Localization_CS;

  return localization;
};
